import { PagesProgressBar as ProgressBar } from 'next-nprogress-bar'
import React from 'react'

const NProgressBar = () => (
  <ProgressBar options={{ showSpinner: false }} disableSameURL shallowRouting />
)

export default NProgressBar
